module.exports = __webpack_public_path__ + "assets/img/avatar-female.c0928ffa.png";